<!--
// app/components/glossary/ConceptLink.vue
//
// How to use:
// <concept-link concept="concept-free-agent" tooltip="Player Status">
//   {{ $t("mercato.status.freeAgent") }}
// </concept-link>
// - concept ID must match the one generated in MercatoKeyConcepts (pattern: concept-<kebab>).
// - Click opens the glossary drawer and scrolls to that concept.
// - Tooltip is optional (title attribute).
-->
<script setup lang="ts">
import InfoIcon from "~/components/Shared/icons/InfoIcon.vue";

type Props = {
  concept: string;
  tooltip?: string;
};

const props = defineProps<Props>();

const openConcept = (conceptId: string) => {
  // Emit custom event to open glossary drawer
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("open-mercato-glossary", {
        detail: { conceptId },
      })
    );
  }
};

const onClick = () => {
  openConcept(props.concept);
};
</script>

<template>
  <button
    type="button"
    class="concept-link inline-flex items-center gap-1 underline decoration-dashed decoration-1 underline-offset-2 transition-all duration-200 cursor-help hover:opacity-80"
    :title="tooltip"
    @click="onClick"
  >
    <slot></slot>
    <InfoIcon />
  </button>
</template>

<style scoped>
.concept-link {
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
}
</style>
